/**
 * BroChat Agent Configuration
 * Health and wellness optimization chat agent
 */

export const broChatConfig = {
  id: 'brochat',
  name: 'BroChat',
  displayName: 'Health Optimizer',
  description: 'Your personal health and wellness optimization assistant',
  
  // Agent branding
  branding: {
    title: 'How will you optimize your well-being today?',
    welcomeMessage: 'How can I help you today?',
    placeholder: 'Message Doc...',
  },

  // API configuration
  api: {
    endpoint: '/api/chat',
    method: 'POST',
    timeout: 30000,
  },

  // Feature flags
  features: {
    imageUpload: true,
    voiceInput: false,
    fileAttachments: false,
    messageHistory: true,
  },

  // UI customization
  ui: {
    showLogo: true,
    showWelcomeMessage: true,
    maxMessageLength: 5000,
    maxImages: 5,
  },
};

export default broChatConfig;
